<template>
  <a-card :bordered="false">
    <div>
      <span style="margin-right:20px;"
      >若超出每日数量可充值流量包，全品类通用。 附加流量包：余量{{ packageNumber }}个</span
      >
      <a-button style="margin-right:20px;" type="primary" @click="openRecharge">充值</a-button>
    </div>
    <a-table style="margin-top:16px;" rowKey="catalogId" ref="tableList" :columns="columns" :dataSource="tableData">
      <span slot="synchronizationStatus" slot-scope="text">
        {{ text === 1 ? '正常' : '禁用' }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a style="margin-right:20px;" @click="handDebug(record)">在线调试</a>
        <a @click="handEditor(record)">编辑</a>
      </span>
    </a-table>
    <a-modal title="流量包充值" :width="460" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-checkbox-group>
        <a-checkbox
          style="margin-left:0;"
          v-for="(item, index) in flowInfoList"
          :key="index"
          :value="item.rechargeMoney"
          disabled
        >
          {{ item.flowNumber }}个，{{ item.rechargeMoney }}元，{{ item.termReminder }}
        </a-checkbox>
      </a-checkbox-group>
      <div style="margin-top:30px">{{ remark }}</div>
      <div class="dialog-footer">
        <a-button style="background-color:#909399;color:#fff;border-color:#909399" @click="visible = false"
        >关闭
        </a-button
        >
      </div>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'ConnectList',
  data() {
    return {
      packageNumber: 0,
      columns: [
        {
          title: '类型ID',
          dataIndex: 'catalogId'
        },
        {
          title: '类型',
          dataIndex: 'catalogName'
        },
        {
          title: '支持商品来源',
          dataIndex: 'productSourceName'
        },
        {
          title: '同步数量限制',
          dataIndex: 'synchronizationLimitQuantity'
        },
        {
          title: '今日同步剩余',
          dataIndex: 'quantity'
        },
        {
          title: '状态',
          dataIndex: 'synchronizationStatus',
          scopedSlots: { customRender: 'synchronizationStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      tableData: [],
      config: [],
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      configId: '',
      visible: false,
      flowInfoList: [],
      remark: ''
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [{ name: 'ErpConnectList', title: '设置' }, {
      name: 'ErpApiSetting',
      title: 'API配置'
    }])
  },
  mounted() {
    this.getConfig()
    this.getConfigurationId()
  },
  methods: {
    getConfigurationId() {
      this.getHttpServices().getServerApiService().post('directAssistant/v2/erp/getConfigurationId', ({
        merchantId: this.merchantId,
        platformId: this.platformId
      })).then(res => {
        sessionStorage.setItem('configurationId', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 获取流量充值信息
    getFlowMsg() {
      this.getHttpServices()
        .getServerApiService()
        .post('zwy/getFlowMsg')
        .then(res => {
          this.flowInfoList = res.flowInfoList
          this.remark = res.remark
        })
        .catch(reason => {
          console.error('===getFlowMsg===', reason)
        })
    },
    // 获取当前配置信息
    getConfig() {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId
      }
      this.getHttpServices()
        .getServerApiService()
        .post('directAssistant/search/getConfiguration', params)
        .then(res => {
          this.config = res
          this.getErpList(res.id)
        })
        .catch(reason => {
          console.error('getConfig', reason)
        })
    },
    // 编辑
    handEditor(record) {
      this.$router.push({
        name: 'ErpConnectSetting',
        query: {
          id: record.id,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    // 调试事件
    handDebug(record) {
      this.$router.push({
        name: 'OnlineDebugging',
        query: {
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    //跳转API配置
    toApiSetting() {
      this.$router.push({
        name: 'ErpApiSetting',
        query: {
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    openRecharge() {
      if (!this.flowInfoList || this.flowInfoList.length < 1) {
        this.getFlowMsg()
      }
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    getErpList(id) {
      const url = 'directAssistant/search/getList/' + id
      return this.getHttpServices()
        .getServerApiService()
        .post(url)
        .then(res => {
          this.tableData = res
        })
        .catch(reason => {
          console.error('getConfig', reason)
        })
    }
  }
}
</script>
<style scoped>
.dialog-footer {
  position: relative;
  left: 85%;
}
</style>